<div class="checkbox-group">
  <div class="checkbox-row" *ngFor="let ckb of checkboxes$ | async">
    <mat-checkbox
      [name]="ckb.option.name"
      [color]="'primary'"
      [checked]="isChecked$(ckb) | async"
      (change)="valueHasChanged(ckb)"
      [disabled]="isDisabled"
    >
      {{ ckb.option.label }}
    </mat-checkbox>
    <h3-training-answer-icon
      *ngIf="trainingAnswers?.[ckb.option.name] === '1'"
    ></h3-training-answer-icon>
  </div>
</div>
